<template>
  <div id="coin_seller_recharge">
    <van-row>
      <van-col span="24">
        <van-col span="24">
          <van-nav-bar
              left-arrow
              placeholder
              safe-area-inset-
              fixed
              @click-left="onClickLeft"
              :title="$t('title.payment')"
          />
        </van-col>
        <van-col span="24" class="coin_seller_recharge_top">
          <van-col span="22" offset="1" class="coin_seller_recharge_top_div">
            <van-col span="24" class="coin_seller_recharge_top_div_img">
              <img :src="list.currency_type_img" v-if="list.currency_type_img"/>
            </van-col>
            <van-col span="24" class="coin_seller_recharge_top_div_title"> {{ $t('column.order_amount') }} </van-col>
            <van-col span="24" class="coin_seller_recharge_top_div_title_money"><span id="recharge_money">{{ list.currency_type_money }} {{ list.currency_type_name }}</span> <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId('recharge_money')"/></van-col>
            <van-col span="24" class="coin_seller_recharge_top_div_title_orderid">{{ $t('column.order_id') }}:<span id="recharge_order">{{ order_id }}</span> <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId('recharge_order')"/></van-col>
          </van-col>
        </van-col>
        <van-col span="22" offset="1" class="coin_seller_recharge_centent">
          <van-col span="22" offset="1" class="coin_seller_recharge_centent_title"> {{ $t('column.please_pay_in_following_way') }} </van-col>
          <van-col span="22" offset="1" class="coin_seller_recharge_centent_name"> {{ $t('column.chain_name') }} </van-col>
          <van-col span="22" offset="1" class="coin_seller_recharge_centent_name_val"> {{ list.payment_name }} </van-col>
          <van-col span="22" offset="1" class="coin_seller_recharge_centent_name" v-if="list.contract_address"> {{ $t('column.contract_address') }} : </van-col>
          <van-col span="22" offset="1" class="coin_seller_recharge_centent_link"> <span id="contract_address">{{ list.contract_address }}</span> </van-col>
          <van-col span="22" offset="1" class="coin_seller_recharge_centent_only"> {{ $t('column.above_address_valid_recharge_only') }} </van-col>
          <van-col span="20" offset="2" class="coin_seller_recharge_centent_btn">
            <van-button color="#FF61F5" block round @click="copyId('contract_address')"> {{ $t('column.copy') }} </van-button>
          </van-col>
          <van-col span="22" offset="1" class="coin_seller_recharge_centent_text">{{ $t('column.increase_coins_proportionally') }}</van-col>
        </van-col>
        <van-col span="24" class="coin_seller_recharge_bottom">
          <van-col span="24" class="coin_seller_recharge_bottom_logo" v-if="short_name">
            <img :src="app_logo" v-if="app_logo"/> {{ short_name }}
          </van-col>
          <van-col span="24" class="coin_seller_recharge_bottom_problem" v-if="kf_email">{{ $t('column.payment_problem') }}</van-col>
          <van-col span="24" class="coin_seller_recharge_bottom_contact" v-if="kf_email">{{ $t('column.please_contact') }}: <span id="customer_service">{{ kf_email }}</span> <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId('customer_service')"/></van-col>
        </van-col>
      </van-col>

    </van-row>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from "axios";
import {Toast} from "vant";
export default {
  data() {
    return {
      order_id: undefined,
      list: {
        currency_type_money: undefined,
        coins: undefined,
        currency_type_img: undefined,
        payment_name: undefined,
        order_id: undefined,
        currency_type_code: undefined,
        currency_type_name: undefined
      },
      kf_email: undefined,
      app_logo: undefined,
      short_name: undefined,
      finished: false
    }
  },
  created() {
    this.order_id = this.$route.query.order_id
    this.convert()
  },
  methods: {
    copyId(id) {
      const element = document.getElementById(id);
      if (!element) {
        Toast('error');
        return;
      }
      // 创建临时textarea元素用于复制
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = element.textContent || element.innerText;
      document.body.appendChild(tempTextArea);
      // 选择并复制文本
      tempTextArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          Toast(this.$t('column.copy_success'));
          // 添加复制成功效果
          if (this.currentButton) {
            this.currentButton.classList.remove('copied');
          }
          this.currentButton = event.currentTarget;
          this.currentButton.classList.add('copied');
          // 3秒后移除复制成功样式
          setTimeout(() => {
            if (this.currentButton) {
              this.currentButton.classList.remove('copied');
            }
          }, 3000);
        } else {
          Toast('copy error');
        }
      } catch (err) {
        Toast('copy error: ' + err);
      }
      // 移除临时元素
      document.body.removeChild(tempTextArea);
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    convert() {
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=seller_order_detail", {
        params : {
          token: token,
          order_id: this.order_id,
        }
      }).then(res =>{
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        }
        this.kf_email = res.data.data.kf_email
        this.app_logo = res.data.data.app_logo
        this.short_name = res.data.data.short_name
        this.list = res.data.data.list

        this.finished = true
      })
    }
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/coin_seller_recharge.vue